// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
import { AiFillRuntimeInput } from 'api/ai-fill/types';
import { User } from 'api/models';
import { StatusUpdate } from 'api/status-updates';
import { TemplateId, TemplateSourceType } from 'data/templates/api';

interface GetStatusUpdatesPayload {
  projectId: number;
}

export interface CreateStatusUpdatesPayload {
  projectId: number;
  private?: boolean;
  title: string;
  collaborators: User[];
  toUsers: User[];
  onSuccess?: (statusUpdate?: StatusUpdate) => void;
  onCreateUpdate?: () => void;
  source?: {
    sourceType: TemplateSourceType;
    sourceId: TemplateId;
  };
  aiFillRuntimeInput?: AiFillRuntimeInput;
  optimistic?: boolean;
}

export interface ChangeStatusUpdatesPayload {
  statusUpdate: StatusUpdate;
  ccUpdate?: boolean;
  onSuccess?: (statusUpdate?: StatusUpdate) => void;
}

export interface ChangeStatusUpdateTitlePayload {
  statusUpdateTitle: string;
  onSuccess?: (statusUpdate?: StatusUpdate) => void;
}

export const createStatusUpdate = createAction<CreateStatusUpdatesPayload>(
  'status-updates/saga/create-status-update',
);

export const getStatusUpdates = createAction<GetStatusUpdatesPayload>(
  'status-updates/saga/get-status-updates',
);

export const putStatusUpdates = createAction<ChangeStatusUpdatesPayload>(
  'status-updates/saga/put-status-update',
);

export const updateStatusUpdateTitle =
  createAction<ChangeStatusUpdateTitlePayload>(
    'status-updates/saga/put-status-update-title',
  );

export const deleteStatusUpdate = createAction<ChangeStatusUpdatesPayload>(
  'status-updates/saga/delete-status-update',
);

export const loadAllStatusUpdates = createAction<StatusUpdate[]>(
  'status-updates/saga/load--all-status-update',
);
export const loadStatusUpdates = createAction<StatusUpdate>(
  'status-updates/saga/load-status-update',
);
export const statusUpdatesLoadingState = createAction<boolean>(
  'status-updates/saga/status-update-loading-state',
);
